import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DetailEditorPropsByYear } from '../types'
import { CoverCropEditorSimple } from './CoverCropEditorSimple'

export const CoverCropEditor = ({
  year,
  name = 'coverCropEditor',
  ...rest
}: DetailEditorPropsByYear) => {
  const { t } = useTranslation(['@cibo/landmanager/CoverCropEditor', '@cibo/ui/cropNames'])
  const previousYear = year - 1

  return (
    <Stack spacing={2} padding={2}>
      <Typography>{t('cta', { year, previousYear })}</Typography>

      <CoverCropEditorSimple year={year} name={name} comfortable {...rest} />
    </Stack>
  )
}
